import { render, staticRenderFns } from "./modalAnadirProductos.vue?vue&type=template&id=4b0bd870"
import script from "./modalAnadirProductos.vue?vue&type=script&lang=js"
export * from "./modalAnadirProductos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports